import { useCallback, useState } from 'react';
import { refreshToken as refreshTokenAPI } from 'api/services/user-service';
import { useNullableAuthContext } from 'hooks/useNullableAuthContext';
import { setAccessTokenGetter } from 'api/config/axios';

const useRefreshToken = () => {
    const [loading, setLoading] = useState(false);
    const authContext = useNullableAuthContext();
    
    const refreshToken = useCallback(async () => {
        try {
            setLoading(true);
            const response = await refreshTokenAPI();

            if (response?.status === 200 && response.data) {
                const newToken = response.data.token;
                const profile = response.data.profile;
                if (authContext) {
                    authContext.userDispatch({ type: 'LOGIN_SUCCESS', payload: { ...profile, token: newToken } });            
                }

                setAccessTokenGetter(() => newToken);
                
                return { success: true, token: newToken, profile };
            } else {
                return { success: false };
            }
        } catch (error) {
            console.error('Failed to refresh token:', error);
            return { success: false };
        } finally {
            setLoading(false);
        }
    }, [authContext]);

    return { refreshToken, loading };
};

export default useRefreshToken;